import { Layout as BaseLayout } from "antd"
import React from "react"

export function Layout(props: React.ComponentProps<typeof BaseLayout>) {
    return <BaseLayout {...props} />
}

Layout.Header = BaseLayout.Header
Layout.Content = BaseLayout.Content
Layout.Footer = BaseLayout.Footer
Layout.Sider = BaseLayout.Sider
